"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var fetch_1 = require("../utils/fetch");
var transform_1 = require("../utils/transform");
exports.default = {
    getMyApplications: function (queryParams) {
        var status = "";
        if (queryParams && queryParams.status) {
            status = queryParams.status.join(",");
        }
        return fetch_1.default("/me/applications", {
            method: "GET",
        }, __assign(__assign({}, (queryParams || {})), (status ? { status: status } : {})));
    },
    getOneApplication: function (id) {
        return fetch_1.default("/applications/" + id, {
            method: "GET",
        });
    },
    getJobApplications: function (jobId, queryParams) {
        var url = "/jobs/" + jobId + "/applications";
        var status;
        if (queryParams && queryParams.status) {
            status = queryParams.status.join(",");
        }
        return fetch_1.default(url, {
            method: "GET",
        }, __assign(__assign({}, (queryParams || {})), (status ? { status: status } : {})));
    },
    createApplication: function (jobId, action) {
        var url = "/jobs/" + jobId + "/applications/" + action;
        return fetch_1.default(url, {
            method: "PUT",
        });
    },
    logApplicationCall: function (id, applicationInput) {
        var url = "/applications/" + id;
        var body = transform_1.toSnakeCase(applicationInput);
        return fetch_1.default(url, {
            method: "PUT",
            body: JSON.stringify(body),
        });
    },
    updateApplication: function (id, input) {
        return fetch_1.default("/applications/" + id, {
            method: "PATCH",
            body: JSON.stringify(transform_1.toSnakeCase(input)),
        });
    },
    resolveApplication: function (id, action, applicationInput) {
        var url = "/applications/" + id + "/" + action;
        var body = transform_1.toSnakeCase(applicationInput);
        return fetch_1.default(url, {
            method: "PUT",
            body: JSON.stringify(body),
        });
    },
};
//# sourceMappingURL=applications.js.map